import { render, staticRenderFns } from "./InfiniteLoader.vue?vue&type=template&id=591ec762&"
import script from "./InfiniteLoader.vue?vue&type=script&lang=ts&"
export * from "./InfiniteLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports